import { type MonetaryValue } from 'ezmoney';

import type { Supplier } from 'modules/suppliers';

import { type InvoiceStatus } from '../../../invoices/models';

type MatchingData =
  | 'amount'
  | 'netAmount'
  | 'date'
  | 'currency'
  | 'supplierId'
  | 'user'
  | 'invoiceNumber'
  | 'creditNoteNumber'
  | 'checksum';

export type Duplicate = {
  matchingData: MatchingData[];
  matchingEntity: {
    id: string;
    owner: {
      id: string;
      name: string;
    };
    supplier: Supplier;
    amount: MonetaryValue;
    description: string;
    date: Date;
  } & (
    | {
        type: 'invoiceRequest';
        invoiceNumber: string;
        status: InvoiceStatus;
        reimbursementPaymentId: string | undefined;
        netAmount: number | null;
      }
    | {
        type: 'creditNoteRequest';
        creditNoteNumber: string;
      }
  );
};

export const findDuplicateAlreadyReviewed = (
  duplicates: Duplicate[],
): Duplicate | undefined =>
  duplicates.find(
    (duplicate) =>
      'status' in duplicate.matchingEntity &&
      ['to-pay', 'partially-paid', 'paid'].includes(
        duplicate.matchingEntity.status,
      ),
  );

export const findDuplicateInReview = (
  duplicates: Duplicate[],
): Duplicate | undefined =>
  duplicates.find(
    (duplicate) =>
      'status' in duplicate.matchingEntity &&
      ['to-review', 'approved'].includes(duplicate.matchingEntity.status),
  );
